import LamboExtCloseUp from 'assets/images/carPage/LamboExtCloseUp.webp';
import LamboExtCloseUpLarge from 'assets/images/carPage/LamboExtCloseUpLarge.webp';
import LamboExtDiagonal from 'assets/images/carPage/LamboExtDiagonal.webp';
import LamboExtDiagonalLarge from 'assets/images/carPage/LamboExtDiagonalLarge.webp';
import LamboExtSide from 'assets/images/carPage/LamboExtSide.webp';
import LamboExtSideLarge from 'assets/images/carPage/LamboExtSideLarge.webp';
import LamboIntA from 'assets/images/carPage/LamboIntA.webp';
import LamboIntALarge from 'assets/images/carPage/LamboIntALarge.webp';
import styles from './CarPicsGrid.module.css';

const CarPicsGrid = () => {
    return (
        <article className={styles.imagesGrid}>
            <img
                alt="Lamborghini exterior diagonally"
                src={LamboExtDiagonalLarge}
                srcSet={`${LamboExtDiagonal} 773w, ${LamboExtDiagonalLarge} 1546w`}
                sizes="(min-width: 758px) 1546px, 773px"
                loading="lazy"
            />
            <img
                alt="Lamborghini interior"
                src={LamboIntALarge}
                srcSet={`${LamboIntA} 357w, ${LamboIntALarge} 714w`}
                sizes="(min-width: 758px) 714px, 357px"
                loading="lazy"
            />
            <img
                alt="Lamborghini exterior close up"
                src={LamboExtCloseUpLarge}
                srcSet={`${LamboExtCloseUp} 357w, ${LamboExtCloseUpLarge} 714w`}
                sizes="(min-width: 758px) 714px, 357px"
                loading="lazy"
            />
            <img
                alt="Lamborghini exterior from side"
                src={LamboExtSideLarge}
                srcSet={`${LamboExtSide} 800w, ${LamboExtSideLarge} 1546w`}
                sizes="(min-width: 758px) 1546px, 800px"
                loading="lazy"
            />
        </article>
    );
};

export default CarPicsGrid;
